export default __webpack_public_path__ + "static/media/cargo.319d2617.jpg";